module.exports = __webpack_public_path__ + "img/Y3.3cf6b465.png";